import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'signet-logo-analyst',
})
export class SignetLogoAnalyst {
  /**
   * Destination of the Logo
   */
  @Prop() href =  "http://analyst.episource.com";
  
  /**
   * SRC of the logo (Optional)
   */
  @Prop() src =  'https://design.episource.com/img/logo/Product=Analyst.svg';

  /**
   * Alternative Text
   */
    @Prop() alt =  'EpiAnalyst Logo';

  private getLogoLink(): string {
    return ( this.href );
  }

  private getImageLink(): string {
    return ( this.src );
  }


  private getAltText(): string {
    return ( this.alt );
  }

  render() {
    return (
      <a class='signet-logo-analyst signet-product-icon' href={this.getLogoLink()}><img src={this.getImageLink()} alt={this.getAltText()} /></a>
    );
  }
}
